<template>
  <div
    class="pengumuman-page"
    :style="pengumumanPageStyle">
    <v-layout wrap>
      <v-flex>
        <section class="pengumuman-section">
          <div>
            <!-- <v-card
              v-if="process.load"
              flat
              height="250"
              width="100vw"
              color="#00000040">
              <v-skeleton-loader
                :loading="process.load"
                transition="scale-transition"
                :tile="false"
                class="ma-auto load_card_x_large"
                type="image"
                style="width: 100% !important; height: 100% !important; min-height: 100% !important;">
              </v-skeleton-loader>
            </v-card> -->
            <div v-if="!process.list">
                <!-- <v-card
                  flat
                  cover
                  v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' "
                  class="background-default">
                  <v-img :src="require('@/assets/image/Candi-Prambanan.jpg')" width="100%" height="250" style="opacity: 0.75;" :gradient="`to right, ${set_color_rgb_up}, #000000a6`" class="img_center align-center">

                    <div class="d-flex align-center justify-center font-weight-black">
                      <div class="text-center">
                        <div
                          class="text-h4 white--text justify-center mb-2 pt-6"
                          style="font-weight: 500;">
                          {{ category[selected.category].category_title }} <span v-if="selected.category === 0">Berita</span>
                        </div>

                        <div
                          class="body-1 white--text text-center mb-4"
                          style="opacity: 50%; font-weight: 500;">
                          Mengenal {{ category[selected.category].category_title }} <span v-if="selected.category === 0">Berita</span> di kabupaten Klaten.
                        </div>
                      </div>
                    </div>

                  </v-img>
                </v-card> -->
            </div>
          </div>
          <v-container :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 'px-0' : ''">
            <!-- Hero: judul (desktop) -->
            <v-row v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'" class="pengumuman-hero-row">
              <v-col cols="12" class="pengumuman-hero-col">
                <div class="pengumuman-hero" :style="{ '--pengumuman-hero-bg': set_color, '--pengumuman-hero-dark': set_color_dark }">
                  <div class="pengumuman-hero-inner">
                    <div class="pengumuman-hero-text">
                      <h1 class="pengumuman-hero-title">Pengumuman</h1>
                      <p class="pengumuman-hero-subtitle">Informasi pengumuman resmi Pemerintah Kabupaten Klaten</p>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>

            <div>
              <v-row>
                <v-col cols="12" md="9" :class="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'pt-0' : ''">
                  <!-- Mobile: judul -->
                  <div v-if="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm'" class="pengumuman-mobile-header mb-4">
                    <h1 class="pengumuman-mobile-title">Pengumuman</h1>
                  </div>
                  <!-- <v-row>
                    <v-col
                      v-for="(item, index) in process.load || process.list ? 8 : list"
                      :key="index"
                      :cols="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 6 : 12"
                      md="4">
                      <v-skeleton-loader
                        :loading="process.load || process.list"
                        transition="scale-transition"
                        :tile="false"
                        class="ma-auto"
                        type="card">
                        <div>
                          <div v-if="!process.list && !process.load && list.length > 0"
                            class="border-radius">
                            <v-card
                              :to="`/pengumuman/${item.slug}?q=${item.id}`"
                              style="border-radius: 6px; box-shadow: rgba(0, 0, 0, 0.01) 0px 3px 5px;"
                              width="100%">
                              <v-img
                                contain
                                :height="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm'  ? 130 : 250"
                                alt="Pemerintah Kabupaten Klaten"
                                :src="item.image_url_cover === '' ? item.image_url === '' ? require('@/assets/image/no-photo.png') : item.image_url : item.image_url_cover"
                                class="ma-auto">

                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center">
                                    <v-progress-circular
                                      indeterminate
                                      :color="set_color">
                                    </v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>

                              <div class="pa-3">
                                <div class="body-2 font-weight-bold one-line">
                                  {{ item.title }}
                                </div>

                                <div class="d-flex align-center mt-1">
                                  <v-icon small color="#212121">mdi-account-circle-outline</v-icon>

                                  <span class="caption one-line ml-1">
                                    Admin
                                  </span>

                                </div>

                                <div class="caption font-weight-light three-line my-2" style="opacity: 60%; min-height: 60px; height: 60px; max-height: 60px;">
                                  <span v-html="item.content.replace(/(<([^>]+)>)/ig, '')"></span>
                                </div>

                                <v-divider class="my-2" style="border: 2px solid #f9f9f9;" />

                                <div class="caption d-flex align-center" style="opacity: 60%;">
                                  <div>
                                    {{ item.publish_datetime | date }}
                                  </div>
                                </div>
                              </div>
                            </v-card>
                          </div>
                        </div>
                      </v-skeleton-loader>
                    </v-col>
                  </v-row> -->


                  <v-card flat
                    v-for="(item, index) in process.list ? 8 : list"
                    :key="index"
                    style="border-radius: 6px;"
                    class="mb-5">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.list"
                      type="list-item-avatar-three-line">
                      <div>
                        <div v-if="!process.list && list.length > 0">
                          <v-list three-line>
                            <template>
                              <v-list-item>
                                <v-list-item-avatar tile :size="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 80 : 60">
                                  <v-img :src="require('@/assets/icon/loudspeaker.png')"></v-img>
                                </v-list-item-avatar>

                                <v-list-item-content :to="item.category_id === '16' ? `/hut-ri/${item.slug}?q=${item.id}` : item.category_id === '15' ? `/hari-jadi-klaten/${item.slug}?q=${item.id}` : `/pengumuman/${item.slug}?q=${item.id}`">
                                  <div @mouseover="voiceHover(item.title)" style="cursor: pointer">{{ item.title }}</div>
                                  <v-list-item-subtitle>
                                    <div>
                                      <v-icon
                                        size="12">
                                        mdi-account-circle-outline
                                      </v-icon>
                                      <span class="me-1 font-small">Admin</span>
                                      <span class="ml-2">
                                        <v-icon
                                          size="12">
                                          mdi-calendar-range
                                        </v-icon>
                                        <span class="me-1 font-small"> {{ item.publish_datetime | date }} </span>
                                      </span>
                                      <span class="ml-2">
                                        <v-icon
                                          size="12">
                                          mdi-eye
                                        </v-icon>
                                        <span class="me-1 font-small">Dilihat {{ item.view_count }} Kali </span>
                                      </span>
                                    </div>
                                  </v-list-item-subtitle>
                                  <v-list-item-subtitle>
                                    <div class="caption font-weight-light three-line my-2" style="opacity: 60%;">
                                      <span v-html="item.content.replace(/(<([^>]+)>)/ig, '')"></span>
                                    </div>
                                  </v-list-item-subtitle>
                                  <!-- <div class="text-right mt-5">
                                    <v-btn
                                      style="border-radius: 6px;"
                                      height="40"
                                      elevation="0"
                                      :small="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? true : true"
                                      color="blue"
                                      class="body-2 text-capitalize font-weight-bold white--text">

                                      <v-icon size="20" class="mr-2">mdi-text-box-search-outline</v-icon>
                                      Lihat Detail
                                    </v-btn>
                                  </div> -->
                                </v-list-item-content>
                                <!-- <v-list-item-action>
                                  <v-chip
                                    class="pa-2"
                                    text-color="white"
                                    x-small
                                    color="green"
                                    label
                                  >
                                    Berlaku
                                  </v-chip>
                                </v-list-item-action> -->
                              </v-list-item>
                              <v-divider></v-divider>
                            <div class="text-right pa-5">
                              <!-- <v-btn
                                style="border-radius: 6px;"
                                elevation="0"
                                :small="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? false : true"
                                color="red"
                                class="text-subtitle-2 text-capitalize font-weight-bold white--text">

                                <v-icon size="20" class="mr-2">mdi-file-document-outline</v-icon>
                                Abstrak
                              </v-btn>
                              <v-btn
                                style="border-radius: 6px;"
                                elevation="0"
                                :small="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? false : true"
                                color="green"
                                class="text-subtitle-2 text-capitalize font-weight-bold white--text">

                                <v-icon size="20" class="mr-2">mdi-download</v-icon>
                                Download
                              </v-btn> -->
                              <v-btn
                                style="border-radius: 6px;"
                                elevation="0"
                                @mouseover="voiceHover('Lihat Detail')"
                                :to="item.category_id === '16' ? `/hut-ri/${item.slug}?q=${item.id}` : item.category_id === '15' ? `/hari-jadi-klaten/${item.slug}?q=${item.id}` : `/pengumuman/${item.slug}?q=${item.id}`"
                                :small="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? false : true"
                                color="blue"
                                class="text-subtitle-2 text-capitalize font-weight-bold white--text">

                                <v-icon size="20" class="mr-2">mdi-text-box-search-outline</v-icon>
                                Lihat Detail
                              </v-btn>
                            </div>
                            </template>
                          </v-list>
                        </div>

                      </div>
                    </v-skeleton-loader>
                  </v-card>

                  <div v-if="!process.list && pagination.total_data > 0"
                    class="pengumuman-pagination mt-4 mb-2">
                    <div class="pengumuman-pagination-inner">
                      <div class="body-2 pengumuman-pagination-info">
                        Total seluruh data: {{ (pagination.total_data || 0).toLocaleString('id-ID') }}
                      </div>
                      <v-pagination
                        v-model="currentPage"
                        :length="totalPages"
                        :total-visible="$vuetify.breakpoint.smAndDown ? 5 : 7"
                        :color="set_color"
                        circle
                        prev-icon="mdi-chevron-left"
                        next-icon="mdi-chevron-right"
                        class="pengumuman-pagination-control"
                        @input="onPageChange"
                      />
                    </div>
                  </div>

                  <Empty v-if="!process.list && pagination.total_page < 1"
                    class="py-12"
                    margin="my-16"
                    size="125"
                    message="Pengumuman" />

                </v-col>
                <v-col cols="12" md="3">

                  <Sidebar />
                </v-col>
              </v-row>
            </div>


          </v-container>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { createSEOMeta } from '@/utils/seo'
  export default {
    middleware: false,
    data () {
      return {
        search: '',
        category: [
          {
            icon: 'mdi-newspaper',
            text: 'Berita',
            link: '/berita?category=utama'
          },
          {
            icon: 'mdi-newspaper-variant',
            text: 'Berita OPD',
            link: '/berita?category=opd'
          },
          {
            icon: 'mdi-newspaper-variant-outline',
            text: 'Berita Wilayah',
            link: '/berita?category=wilayah'
          },
        ],
        selected: {
          category: 0
        },
        filter: {
          category: ''
        },
        total_category: 0,
        list: [],
        pagination: {},
        currentPage: 1,
        pageSize: 12,
        process: {
          load: false,
          list: false
        },
        message: {
          success: '',
          error: ''
        },
        // SEO
        content: {
          url: '/berita',
          title: 'Berita',
          description: 'Berita Kabupaten Klaten',
          image: require('@/assets/logo/favicon.png')
        }
      }
    },
    head () {
      return {
        title: this.content.title,
        meta: createSEOMeta(this.content)
      }
    },
    // components: {
    //   Utama: () => import(/* webpackPrefetch: true */ '@/components/berita/utama.vue'),
    //   OPD: () => import(/* webpackPrefetch: true */ '@/components/berita/opd.vue'),
    //   Wilayah: () => import(/* webpackPrefetch: true */ '@/components/berita/wilayah.vue'),
    // },
    components: {
      Empty: () => import(/* webpackPrefetch: true */ '@/components/Empty'),
      Sidebar: () => import(/* webpackPrefetch: true */ '@/components/sidebar/index')
    },
    watch: {
      '$route.query.category': function(val) {
        this.changeLink(val)
      },
      '$route.query.search': function(val) {
        this.changeLink()
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.member.auth.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.header.config.color
      },
      set_color_dark () {
        const hex = (this.$store.state.header.config.color || '#B71C1C').replace(/^#/, '')
        const r = Math.max(0, parseInt(hex.slice(0, 2), 16) * 0.65)
        const g = Math.max(0, parseInt(hex.slice(2, 4), 16) * 0.65)
        const b = Math.max(0, parseInt(hex.slice(4, 6), 16) * 0.65)
        return '#' + [r, g, b].map(x => Math.round(x).toString(16).padStart(2, '0')).join('')
      },
      pengumumanPalette () {
        const primary = this.set_color || '#B71C1C'
        return {
          '--pengumuman-bg': '#FAF7F5',
          '--pengumuman-surface': '#FFFFFF',
          '--pengumuman-text': '#2D2D2D',
          '--pengumuman-text-muted': '#6B6B6B',
          '--pengumuman-border': '#E8E4E0',
          '--pengumuman-primary': primary,
          '--pengumuman-primary-soft': primary + '14',
          '--pengumuman-accent': '#B8860B',
          '--pengumuman-shadow': '0 2px 12px rgba(45, 45, 45, 0.06)',
          '--pengumuman-shadow-hover': '0 8px 24px rgba(45, 45, 45, 0.1)'
        }
      },
      pengumumanPageStyle () {
        const isDesktop = this.$vuetify.breakpoint.name !== 'xs' && this.$vuetify.breakpoint.name !== 'sm'
        const padding = isDesktop
          ? { paddingTop: '128px', paddingBottom: '280px' }
          : { paddingTop: '64px', paddingBottom: '650px' }
        return Object.assign({}, this.pengumumanPalette, padding)
      },
      totalPages () {
        const total = this.pagination.total_page ?? Math.ceil((this.pagination.total_data || 0) / this.pageSize)
        return Math.max(1, total)
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchCategory()
    },
    methods: {
      voiceHover (item) {
        responsiveVoice.cancel(); // Cancel anything else that may currently be speaking
        responsiveVoice.speak(item, 'Indonesian Female');
      },
      async fetchCategory (id, type) {
        this.process.load = type === undefined ? true : false
        this.process.list = true

        let params = {
          limit: 1000000,
          par_id: '1'
        }

        await this.$axios.$get(`${process.env.API}sites/article/category`, { params })
        .then(response => {
          let res = response

          if (res.status === 200) {
            this.category = [
              {
                category_title: "Semua Kategori",
                category_icon_url: require('@/assets/icon/app.png'),
                id: '',
                category_name: "semua-kategori",
                count: 0
              }
            ]
            let category = []
            category = res.results.data.map(item => {
                const container = {};

                container.category_title = item.title;
                container.category_icon_url = item.icon_url;
                container.id = item.id;
                container.category_name = item.slug;
                container.count = item.count

                // this.category = container;
                return container
              })


            for (let i in category) {
              this.category.push(
                {
                  category_title: category[i].category_title,
                  category_icon_url: category[i].category_icon_url,
                  id: category[i].id,
                  category_name: category[i].category_name,
                  count: category[i].count
                }
              )

            }

            for (let i in this.category) {
              this.total_category += parseInt(this.category[i].count)

            }

            this.process.load = false
            this.category[0].count = this.total_category
            this.changeLink()
          }
        })
      },
      onPageChange () {
        this.fetch()
        window.scrollTo({ top: 0, behavior: 'smooth' })
      },
      async fetch () {
        this.process.list = true

        let params = {
          'title[lse]': this.$route.query.search === undefined ? '' : this.$route.query.search,
          limit: this.pageSize,
          page: this.currentPage,
          'category_id[in]': '2,16,15',
          sort: '-publish_datetime'
        }

        await this.$axios.$get(`${process.env.API}sites/article/data`, { params })
        .then(response => {
          let res = response

          if (res.status === 200) {
            this.list = res.results.data
            this.pagination = res.results.pagination
          }
          this.process.list = false
          this.process.load = false
        })
      },
      changeLink() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        let status = false
        let id = 0
        this.selected.category = 0
        this.filter.category = ''
        this.currentPage = 1


        if (this.$route.query.category !== undefined) {
          for(let i = 0; i < this.category.length; i++){
            if (this.category[i].category_name === this.$route.query.category) {
              this.filter.category = this.category[i].id
              this.selected.category = i
              status = true
            } else {
              // status = false
            }
          }
          // if (query === 'wisata') {
          //     this.selected = {
          //       category: 0,
          //     }
          // } else if (query === 'kuliner') {
          //   this.selected = {
          //     category: 1
          //   }
          // }
          // this.fetch(id)
        }
        // console.log(status)
        if (status === false) {
          this.$router.push(`/pengumuman`)
        }

        console.log(id)

        this.fetch()
      },
      changeQuery(name) {
        if(name === '') {
          if (this.$route.query.search !== undefined) {
            this.$router.replace({'path': `/berita`, 'query': {'search': this.$route.query.search}})
          } else {
            this.$router.replace({'path': `/berita`})
          }
        } else {
          if (this.$route.query.search === undefined) {
            this.$router.replace({'path': `/berita`, 'query': {'category': name}})
          } else {
            this.$router.replace({'path': `/berita`, 'query': {'category': name, 'search': this.$route.query.search}})
          }
        }
      },
      // toDetail(item) {
      //   this.$router.push(`/pengumuman/${(item.title.split('-').join('=').split(' ').join('-').split('/').join('>'))}?q=${item.id}`)
      // },
    }
  }
</script>

<style scoped>
/* ---- Page ---- */
.pengumuman-page {
  background-color: var(--pengumuman-bg);
  min-height: 100vh;
  box-sizing: border-box;
}

.pengumuman-section {
  min-height: 0;
}

/* ---- Hero (desktop) ---- */
.pengumuman-hero-row {
  margin-bottom: 2rem;
}

.pengumuman-hero-col {
  padding-top: 0;
  padding-bottom: 0;
}

.pengumuman-hero {
  background: linear-gradient(135deg, var(--pengumuman-hero-bg) 0%, var(--pengumuman-hero-dark) 100%);
  border-radius: 16px;
  padding: 1.75rem 2rem;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
}

.pengumuman-hero-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.pengumuman-hero-text {
  flex: 0 0 auto;
}

.pengumuman-hero-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: #fff;
  margin: 0 0 0.25rem 0;
  letter-spacing: -0.02em;
}

.pengumuman-hero-subtitle {
  font-size: 0.9375rem;
  color: rgba(255, 255, 255, 0.88);
  margin: 0;
}

/* ---- Mobile header ---- */
.pengumuman-mobile-header {
  background: var(--pengumuman-surface);
  border-radius: 12px;
  padding: 1rem;
  box-shadow: var(--pengumuman-shadow);
  border: 1px solid var(--pengumuman-border);
}

.pengumuman-mobile-title {
  font-size: 1.375rem;
  font-weight: 700;
  color: var(--pengumuman-text);
  margin: 0;
}

/* ---- Pagination ---- */
.pengumuman-pagination {
  width: 100%;
}

.pengumuman-pagination-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem 1.25rem;
  background: var(--pengumuman-surface);
  border: 1px solid var(--pengumuman-border);
  border-radius: 12px;
  box-shadow: var(--pengumuman-shadow);
}

.pengumuman-pagination-info {
  color: var(--pengumuman-text-muted);
  font-size: 0.875rem;
}

.pengumuman-pagination-control.v-pagination {
  flex-wrap: wrap;
  justify-content: center;
}

.pengumuman-pagination-control.v-pagination .v-pagination__item,
.pengumuman-pagination-control.v-pagination .v-pagination__navigation {
  min-width: 36px !important;
  width: 36px !important;
  height: 36px !important;
  margin: 0 3px !important;
  font-weight: 600;
  font-size: 0.875rem;
  box-shadow: none;
  border: 1px solid var(--pengumuman-border);
}

.pengumuman-pagination-control.v-pagination .v-pagination__item--is-active {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.pengumuman-pagination-control.v-pagination .v-pagination__more {
  margin: 0 2px;
  min-width: 28px;
}

@media (max-width: 600px) {
  .pengumuman-pagination-inner {
    flex-direction: column;
    align-items: stretch;
    text-align: center;
  }

  .pengumuman-pagination-control.v-pagination .v-pagination__item,
  .pengumuman-pagination-control.v-pagination .v-pagination__navigation {
    min-width: 32px !important;
    width: 32px !important;
    height: 32px !important;
  }
}
</style>
